var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-spinner",style:({color: _vm.color, fontSize: _vm.fontSize}),attrs:{"role":"progressbar"}},_vm._l((_vm.lines),function(line){return _c('div',{key:line})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }